import React from 'react'

export const Checkmark = () => (
  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 1L5 9.74961L1 5.375" stroke="#2647D7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)
